// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bg-get-started[data-v-bf28525e] {\n  background: linear-gradient(129.86deg, #08f -2.99%, #001b7b 201.26%);\n}\n", ""]);
// Exports
module.exports = exports;
